import { bindActionCreators } from 'redux';
import { isItShowingLoad, isItActionShowingLoad, getLoadType, isConfirmed } from 'state/loading/selectors';
import { showDrawer, showModal, showAlertModal } from 'state/modal-drawer/selectors';
import { getLoginData, getUserLoginSettings, getSettings } from 'state/logged-user/selectors';
import {
  getOrdersData,
  getReturnedOrdersData,
  getOrderDetails,
  getRAData,
  getDataEntry,
  getRecipientData,
  getCarrierServiceData,
  getOrderTypesData,
  getOrderInfo,
  getFilters,
  getAutoCompleteRecipient,
  getimportInfo,
  getimportOrders,
  getSortColumn,
  getSortType,
  getAutoCompleteOrders,
  getOrderStatusesData,
  getOrderFile,
  getCSVOrder,
  getImportCSVOrder,
} from 'state/orders/selectors';
import {
  fetchOrderList,
  fetchMoreOrderList,
  fetchOrderDetail,
  fetchOrderItems,
  setRAData,
  setDataEntry,
  fetchReturnOrderList,
  fetchMoreReturnOrderList,
  addOrderRecipient,
  saveOrderRecipient,
  getCarrierService,
  setOrderInfo,
  addSalesOrder,
  addReturnOrders,
  setFilters,
  autocompleteRecipient,
  resetRecipientAutocomplete,
  importsInfo,
  importOrders,
  setSortColumn,
  setSortType,
  updateSalesOrder,
  autocompleteOrder,
  resetOrderAutocomplete,
  cancelOrder,
  getOrderStatuses,
  setOrderFile,
  reviewCSVOrder,
  importCSVOrder,
  clearImportCSVOrder,
  fetchThirdPartyList,
  fetchMoreThirdPartyList,
  fetchThirdPartyDetail,
} from 'state/orders/actions';
import { setLoadType, setConfirmed } from 'state/loading/actions';
import { getAutoCompleteProduct } from 'state/products/selectors';
import { autocompleteProduct, resetProductAutocomplete } from 'state/products/actions';
import { getCountries, getAddressData } from 'state/address/selectors';
import { setUserSettings } from 'state/logged-user/actions';
import * as uiActionCreators from 'state/modal-drawer/actions';

export const mapStateToProps = state => ({
  orders: getOrdersData(state),
  returnedorders: getReturnedOrdersData(state),
  loading: isItShowingLoad(state),
  drawer: showDrawer(state),
  modal: showModal(state),
  alertModal: showAlertModal(state),
  actionloading: isItActionShowingLoad(state),
  getloadtype: getLoadType(state),
  confirmed: isConfirmed(state),
  detail: getOrderDetails(state),
  radata: getRAData(state),
  dataentry: getDataEntry(state),
  profile: getLoginData(state),
  usersettings: getUserLoginSettings(state),
  autoRecipient: getAutoCompleteRecipient(state),
  countries: getCountries(state),
  addressData: getAddressData(state),
  recipientdata: getRecipientData(state),
  carrierdata: getCarrierServiceData(state),
  ordertypesdata: getOrderTypesData(state),
  formdata: getOrderInfo(state),
  autoProduct: getAutoCompleteProduct(state),
  filtersdata: getFilters(state),
  settings: getSettings(state),
  getimportinfo: getimportInfo(state),
  getimportorders: getimportOrders(state),
  sortcolumn: getSortColumn(state),
  sorttype: getSortType(state),
  autoOrders: getAutoCompleteOrders(state),
  orderstatuses: getOrderStatusesData(state),
  orderfile: getOrderFile(state),
  csvorder: getCSVOrder(state),
  importcsvorderdata: getImportCSVOrder(state),
});

export const mapDispatchToProps = dispatch => ({
  orderList: (
    type, limit, page, text, start, end, name, code, company, email,
    sortColumn, sortType,
  ) => dispatch(fetchOrderList(
    type, limit, page, text, start, end, name, code, company, email,
    sortColumn, sortType,
  )),
  moreOrderList: (
    type, limit, page, text, start, end, name, code, company, email,
    sortColumn, sortType,
  ) => dispatch(fetchMoreOrderList(
    type, limit, page, text, start, end, name, code, company, email,
    sortColumn, sortType,
  )),
  returnOrderList: (
    status, limit, page, text, start, end, name, company, email,
    sortColumn, sortType,
  ) => dispatch(fetchReturnOrderList(
    status, limit, page, text, start, end, name, company, email,
    sortColumn, sortType,
  )),
  moreReturnOrderList: (
    status, limit, page, text, start, end, name, company, email,
    sortColumn, sortType,
  ) => dispatch(fetchMoreReturnOrderList(
    status, limit, page, text, start, end, name, company, email,
    sortColumn, sortType,
  )),
  thirdPartyList: (
    status, limit, page, text, start, end, name, company, email,
    sortColumn, sortType,
  ) => dispatch(fetchThirdPartyList(
    status, limit, page, text, start, end, name, company, email,
    sortColumn, sortType,
  )),
  moreThirdPartyList: (
    status, limit, page, text, start, end, name, company, email,
    sortColumn, sortType,
  ) => dispatch(fetchMoreThirdPartyList(
    status, limit, page, text, start, end, name, company, email,
    sortColumn, sortType,
  )),
  orderDetail: id => dispatch(fetchOrderDetail(id)),
  ordeItems: ranumber => dispatch(fetchOrderItems(ranumber)),
  actions: { ui: bindActionCreators(uiActionCreators, dispatch) },
  setloadtype: type => dispatch(setLoadType(type)),
  setconfirmed: type => dispatch(setConfirmed(type)),
  setradata: data => dispatch(setRAData(data)),
  setdataentry: data => dispatch(setDataEntry(data)),
  getAutoRecipient: txt => dispatch(autocompleteRecipient(txt)),
  resetAutoRecipient: () => dispatch(resetRecipientAutocomplete()),
  addrecipient: data => dispatch(addOrderRecipient(data)),
  saverecipient: (id, data) => dispatch(saveOrderRecipient(id, data)),
  getCarrier: () => dispatch(getCarrierService()),
  setformdata: data => dispatch(setOrderInfo(data)),
  getAutoProduct: txt => dispatch(autocompleteProduct(txt)),
  resetAutoProduct: txt => dispatch(resetProductAutocomplete(txt)),
  addsalesorder: (data, id) => dispatch(addSalesOrder(data, id)),
  addreturnorders: data => dispatch(addReturnOrders(data)),
  setfilters: data => dispatch(setFilters(data)),
  setsettings: (uid, data) => dispatch(setUserSettings(uid, data)),
  importsInfo: () => dispatch(importsInfo()),
  importOrders: () => dispatch(importOrders()),
  setSortColumn: column => dispatch(setSortColumn(column)),
  setSortType: type => dispatch(setSortType(type)),
  updatesalesorder: data => dispatch(updateSalesOrder(data)),
  getAutoOrder: txt => dispatch(autocompleteOrder(txt)),
  resetAutoOrder: () => dispatch(resetOrderAutocomplete()),
  cancelOrder: id => dispatch(cancelOrder(id)),
  getOrderStatuses: () => dispatch(getOrderStatuses()),
  setOrderFile: data => dispatch(setOrderFile(data)),
  reviewCSVOrder: data => dispatch(reviewCSVOrder(data)),
  importCSVOrder: data => dispatch(importCSVOrder(data)),
  clearImportCSVOrder: () => dispatch(clearImportCSVOrder()),
  thirdPartyDetail: id => dispatch(fetchThirdPartyDetail(id)),
});

